export default function hasComplexPasswordValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link(scope, elem, attrs, ngModel) {
      ngModel.$parsers.unshift((value) => {
        if (ngModel.$pristine) {
          return value;
        }
        if (!angular.isString(value)) {
          return value;
        }
        value = value.trim();
        if (value === '') {
          return value;
        }
        if (value.length < 8) {
          return value;
        }

        const hasLower = value.search(/[a-z]+/g) > -1;
        const hasUpper = value.search(/[A-Z]+/g) > -1;
        const hasNumber = value.search(/\d+/g) > -1;
        const hasSymbol = value.search(/[#$^+=!*()@%&[\]{}\-_:;"'<>,.?/\\|`~]+/g) > -1;

        let complexity = 0;
        if (hasLower) complexity += 1;
        if (hasUpper) complexity += 1;
        if (hasNumber) complexity += 1;
        if (hasSymbol) complexity += 1;

        const isValid = complexity >= 3;

        ngModel.$setValidity('hasComplexPassword', isValid);
        return value;
      });
    }
  };
}
